import { FC } from 'react';

import { OrdersService } from '../../services/OrdersService';
import { OfferProperty } from '../../types';
import { cn } from '../../utils';

interface Props {
    propertySet?: Record<string, string> | null;
    legacyCondition?: string;
    offerProperties: OfferProperty[];
    productTypeId?: number;
    className?: string;
    dataTestId?: string;
}

export const OfferPropertiesText: FC<Props> = ({
    propertySet,
    legacyCondition,
    offerProperties,
    productTypeId,
    className,
    dataTestId,
}) => {
    const normalizedPropertySet = {
        ...(legacyCondition ? { condition: legacyCondition } : {}),
        ...(propertySet ?? {}),
    };
    const productOfferProperties = productTypeId
        ? offerProperties.filter(
              (property) => property.product_type_id === productTypeId,
          )
        : offerProperties;
    const label = OrdersService.getOfferPropertyEntries(
        normalizedPropertySet,
        productOfferProperties,
    )
        .map(({ key, value }) => `${key}: ${value}`)
        .join(', ');

    if (!label) {
        return null;
    }

    return (
        <p
            className={cn(
                'text-xs break-words text-muted-foreground',
                className,
            )}
            data-testid={dataTestId}
        >
            {label}
        </p>
    );
};
